import React from "react";

const ClinicInfoText = ({ clinicInfo, logoDimensions }) => {
    const VerificationWarning = ({ isVerified, fieldName }) => {
        return (
            <>
                {isVerified ? (
                    <span className="text-success ms-2" title={`${fieldName} verified`}>
                    <i className="bi bi-check-circle-fill"></i>
                </span>
                ) : (
                    <span className="text-warning ms-2" title={`${fieldName} not verified`}>
                    <i className="bi bi-exclamation-triangle-fill"></i>
                </span>
                )}
            </>
        );
    };

    return (
        <div className="row g-4">
            <div className="col-md-8">

                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title mb-3">
                            <i className="bi bi-info-circle me-2"></i> Basic Information
                        </h4>
                        <table className="table table-striped">
                            <tbody>
                            <tr>
                                <th scope="row" className="w-25">Clinic Name</th>
                                <td>{clinicInfo?.name || "—"}</td>
                            </tr>
                            <tr>
                                <th scope="row">Number</th>
                                <td>{clinicInfo?.number || "—"}</td>
                            </tr>
                            <tr>
                                <th scope="row">Type</th>
                                <td>{clinicInfo?.clinicType || "—"}</td>
                            </tr>
                            <tr>
                                <th scope="row">Started</th>
                                <td>{clinicInfo?.dateStarted || "—"}</td>
                            </tr>
                            <tr>
                                <th scope="row">Clinic Signature</th>
                                <td>{clinicInfo?.signature || "—"}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div className="col-md-4">
                {clinicInfo?.status === "ON" ? (
                    <div className="card border-0 shadow-sm mb-4">
                        <div className="card-body p-4">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <div className="bg-success bg-opacity-10 p-3 rounded-circle">
                                        <i className="bi bi-check-circle-fill text-success fs-2"></i>
                                    </div>
                                </div>
                                <div className="col">
                                    <h4 className="mb-1 text-success fw-bold">Clinic Status: Active</h4>
                                    <p className="text-muted mb-0">Your Eyeconx service is functional.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="card border-0 shadow-sm mb-4">
                        <div className="card-body p-4">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <div className="bg-danger bg-opacity-10 p-3 rounded-circle">
                                        <i className="bi bi-x-circle-fill text-danger fs-2"></i>
                                    </div>
                                </div>
                                <div className="col">
                                    <h4 className="mb-1 text-danger fw-bold">Clinic Status: Inactive</h4>
                                    <p className="text-muted mb-0">Your service is stopped.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
                <div className="card bg-light">
                    <div className="card-body">
                        <h6 className="card-title">
                            <i className="bi bi-image me-2"></i> Clinic Logo
                        </h6>
                        {clinicInfo.logo && (
                            <div className="d-flex flex-column gap-2 align-items-center">
                                <img
                                    src={clinicInfo.logo}
                                    alt="Clinic Logo"
                                    className="img-thumbnail me-3"
                                    style={{ objectFit: "contain" }}
                                />

                            </div>
                        )}
                    </div>
                </div>
            </div>



            <div className="col-md-12">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title mb-3">
                            <i className="bi bi-telephone me-2"></i> Contact Information
                        </h4>
                       <div className="container">
                           <div className="row">
                               <div className="col-md-8">
                                   {/* Table */}
                                   <table className="table table-striped">
                                       <tbody>
                                       <tr>
                                           <th scope="row" className="w-25">Email</th>
                                           <td className="d-flex align-items-center">
                                               {clinicInfo?.email ? (
                                                   <a href={`mailto:${clinicInfo.email}`}>{clinicInfo.email}</a>
                                               ) : (
                                                   "—"
                                               )}
                                               <VerificationWarning
                                                   isVerified={clinicInfo?.verification?.email}
                                                   fieldName="Email"
                                               />
                                           </td>
                                       </tr>

                                       <tr>
                                           <th scope="row">Phone</th>
                                           <td className="d-flex align-items-center">
                                               {clinicInfo?.phone ? (
                                                   <a href={`tel:${clinicInfo.phone}`}>{clinicInfo.phone}</a>
                                               ) : (
                                                   "—"
                                               )}
                                               <VerificationWarning
                                                   isVerified={clinicInfo?.verification?.phone}
                                                   fieldName="Phone"
                                               />
                                           </td>
                                       </tr>

                                       <tr>
                                           <th scope="row">SMS</th>
                                           <td className="d-flex align-items-center">
                                               {clinicInfo?.sms || "—"}
                                               <VerificationWarning
                                                   isVerified={clinicInfo?.verification?.sms}
                                                   fieldName="SMS"
                                               />
                                           </td>
                                       </tr>

                                       <tr>
                                           <th scope="row">Website</th>
                                           <td>
                                               {clinicInfo?.website ? (
                                                   <a
                                                       href={clinicInfo.website}
                                                       target="_blank"
                                                       rel="noreferrer"
                                                   >
                                                       {clinicInfo.website}
                                                   </a>
                                               ) : (
                                                   "—"
                                               )}
                                           </td>
                                       </tr>


                                       </tbody>
                                   </table>

                               </div>
                               <div className="col-md-4">
                                   {clinicInfo?.verification?.email && clinicInfo?.verification?.phone && clinicInfo?.verification?.sms ? (
                                       <div className="card bg-success bg-opacity-50 mb-3">
                                           <div className="card-body d-flex align-items-start">
                                               <i className="bi bi-check-circle-fill text-dark fs-1 me-3"></i>
                                               <div>
                                                   <h6 className="fw-bold mb-1">Verified Records</h6>
                                                   <p className="mb-0 small">
                                                       Email, SMS, and Phone are all verified.
                                                   </p>
                                               </div>
                                           </div>
                                       </div>
                                   ) : (
                                       <div className="card bg-warning bg-opacity-50 mb-3">
                                           <div className="card-body d-flex align-items-start">
                                               <i className="bi bi-exclamation-circle-fill text-dark fs-1 me-3"></i>
                                               <div>
                                                   <h6 className="fw-bold mb-1">Verification Required</h6>
                                                   <p className="mb-0 small">
                                                       Verify your <strong>email, SMS</strong>, and <strong>phone numbers</strong> to ensure you receive the most accurate information.
                                                   </p>
                                               </div>
                                           </div>
                                       </div>
                                   )}
                               </div>

                           </div>
                       </div>

                    </div>
                </div>


            </div>

            <div className="col-8">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title mb-3">
                            <i className="bi bi-geo-alt me-2"></i> Address
                        </h4>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-8"></div>
                                <div className="col-md-4">

                                </div>
                            </div>
                        </div>
                        <address>
                            {clinicInfo.street} <br />
                            {clinicInfo.city}, {clinicInfo.province} {clinicInfo.postalCode} <br />
                            {clinicInfo.country}
                        </address>
                    </div>
                </div>

            </div>
            <div className="col-md-4">
                <div className="card bg-light">
                    <div className="card-body">
                        <h6 className="card-title">
                            <i className="bi bi-clock me-2"></i> Timezone
                        </h6>
                        <span className="fw-bold fs-5">
                            {clinicInfo?.timezone?.timezoneName || "—"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClinicInfoText;
